import { render } from "./WaypointsTest.vue?vue&type=template&id=4e7b6c32&bindings={\"dialogue\":\"data\",\"card\":\"data\"}"
import script from "./WaypointsTest.vue?vue&type=script&lang=js"
export * from "./WaypointsTest.vue?vue&type=script&lang=js"
script.render = render

export default script